(function() {
    'use strict';

    angular.module( APP_ID )
        .controller( 'StudyAreasController', [ '$scope', '$controller', 'ContentSwitchingService', 'SubpagesService', 'LoggerFactory', 'TEXTS', 'CONFIG', StudyAreasController ]);

    /**
     * Downloads and prepares data for a single study area.
     *
     * @param {ng.IScope} $scope
     * @param {ng.IControllerService} $controller
     * @param {ContentSwitchingService} ContentSwitchingService
     * @param {SubpagesService} SubpagesService
     * @param {LoggerFactory} LoggerFactory
     * @param {Object} TEXTS
     * @param {Object} CONFIG
     */
    function StudyAreasController(
        $scope,
        $controller,

        ContentSwitchingService,
        SubpagesService,
        LoggerFactory,

        TEXTS,
        CONFIG
    ){
        // Helper members.

        /** @type {angular.IController} */
        var vm = this;

        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'StudyAreasController' );

        /** @type {BaseController} */
        var ctrl   = $controller( 'BasePageController', { 'vm': vm, 'logger': logger } );





        /* ===== CONSTANTS ================================================== */


        /** @const */
        var SUBJECT_LISTING_BLOCK_TYPE = 'subject-listing';





        /* ===== CONTROLLER'S PUBLIC API ==================================== */


        // Members (+ their defaults)
        vm.relatedAreas   = undefined;





        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        function init(){
            overrideBaseController();
            ctrl.activate();

            SubpagesService.setSubpagesFromChildren();
        }

        /** Run right after all the bindings are ready! */
        vm.$onInit = init;





        /* ===== CONTROLLER'S PUBLIC METHODS ================================ */


        /**
         * _TODO: MUST be removed after its migrated to the dynamic
         * blocks in the CMS._
         *
         * @deprecated Use dynamic block instead of value hard-coded inside the
         * template!
         *
         * @param {Object[]} dynamicBlocks
         *
         * @returns {(boolean|void)}
         */
        function isSubjectListingDynamicBlock( dynamicBlocks ) {
            if ( !dynamicBlocks ) return;

            return dynamicBlocks.some( function( block ) {
                return ( block.contentType === SUBJECT_LISTING_BLOCK_TYPE );
            });
        }





        /* ===== PRIVATE FUNCTIONS ========================================== */


        /**
         * Overrides parental's controller behaviour and attaches hooks.
         *
         * _Note: MUST BE called BEFORE the parental controller is activated!_
         */
        function overrideBaseController() {
            ctrl.contentRequestParams = {
                viewUrl: vm.$transition$.params()[ CONFIG.PARAMS.STUDY_AREA_ID ],
                urlPath: CONFIG.API.CMS.PATHS.STUDY_AREAS
            };

            ctrl.requiredContentAttributes.push( 'asset_contents', 'studyOptions', 'peopleAndStories', 'asset_subjects' );
            ctrl.preProcessResponse  = preProcessResponse;
            ctrl.postProcessResponse = exposeDataWhereNeeded;
        }


        /**
         * Is triggered right after getting response from CMS,
         * validating all required attributes and before processing
         * part of the response.
         *
         * @param {Object} responseObject
         */
        function preProcessResponse( responseObject ) {
            vm.relatedAreas           = responseObject.relatedAreasOfStudy;
            vm.content.aboutBlocks    = responseObject.asset_contents;
            vm.content.studyBlocks    = responseObject.studyOptions.asset_contents;
            vm.content.peopleBlocks   = responseObject.peopleAndStories.asset_contents;
            vm.content.subjectsBlocks = responseObject.asset_subjects;
        }

        /**
         * Enhances content by adding extra data or references that can be
         * later used in underlying components.
         */
        function exposeDataWhereNeeded() {
            var singleBlockContent, i;

            for( i = 0; i < vm.content.aboutBlocks.length; i++ ) {
                singleBlockContent = vm.content.aboutBlocks[ i ];
                if ( singleBlockContent.contentType === 'intro-about' ){
                    singleBlockContent.subjects = vm.content.subjectsBlocks;
                };
            };

            saveInfoToCookie();
            setDynamicBlocksSettings();

            // Expose to the controller
            /** @deprecated */
            vm.isSubjectListingDynamicBlock = isSubjectListingDynamicBlock( vm.content.studyBlocks );
        }



        /**
         * Saves information about current study areas and selected major(s)
         * into a cookie, if it was already created by the `ContentSwitchingService`.
         */
        function saveInfoToCookie() {
            var lastVisitedPage = ContentSwitchingService.userSettings.lastVisitedPage;

            if ( !lastVisitedPage.hasOwnProperty( 'studyArea' ) ) lastVisitedPage[ 'studyArea' ] = {};

            lastVisitedPage.studyArea[ 'webPath' ] = vm.metadata.id;

            // Save updated user information to the cookies!
            if ( ContentSwitchingService.isCookieAvailable() ) ContentSwitchingService.saveSettingsToCookie();
        }



        /**
         * Settings that can be propagated down the dynamic blocks
         * generator as a `customData` and wired to custom block
         * component's binding through 'renderingOptions' attribute.
         */
        function setDynamicBlocksSettings () {
            if ( vm.content.subjectsBlocks ){
                vm.dynamicBlocksSettings = {};

                // For `subjects` binding inside subjects-listing.component.js
                vm.dynamicBlocksSettings.subjects = vm.content.subjectsBlocks;
            } else {
                logger.warn( "Cannot set `subjects` of this study area. Attribute `asset_subjects` is not available in the response." )
            }
        }
    }
})();
